import * as moment from 'moment'
export const SCREEN_IS_SMALL = window.innerWidth < 768

export const OUTPUT_DATE_FORMAT = 'DD.MM.YYYY'
export const REQUEST_DATE_FORMAT = 'YYYY-MM-DD'
export const RUSSIAN_DATE_FORMAT = 'DD.MM.YYYY'

export const STANDARD_ITEM_RULES = [{required: true, message: 'Введите данные'}]
export const STANDARD_ITEM_RULES_POSITIVE_SUM = [
    ...STANDARD_ITEM_RULES,
    {
        validator: async (rule, value) => {
            if (value < 1) {
                throw new Error('Сумма должна быть больше нуля')
            }
            if (!/^\d+$/.test(value)) {
                throw new Error('Должны присутствовать только цифры')
            }
        },
    },
]
export const STANDARD_ITEM_RULES_ADULT = [
    ...STANDARD_ITEM_RULES,
    {
        validator: async (r, v) => {
            if (moment().diff(v, 'years') < 18)
                return Promise.reject('Должен быть совершеннолетним')
            return Promise.resolve()
        },
    },
]
export const STANDARD_ITEM_RULES_5_YEARS = [
    ...STANDARD_ITEM_RULES,
    {
        validator: async (r, v) => {
            if (moment().diff(v, 'years') < 5)
                return Promise.reject('Застрахованный должен быть старше пяти лет')
            return Promise.resolve()
        },
    },
]
export const STANDARD_ITEM_RULES_5_70_YEARS = [
    ...STANDARD_ITEM_RULES,
    {
        validator: async (r, v) => {
            if (moment().diff(v, 'years') < 5)
                return Promise.reject('Застрахованный должен быть старше пяти лет')
            if (moment().diff(v, 'years') > 70)
                return Promise.reject('Застрахованный должен быть младше 70 лет')
            return Promise.resolve()
        },
    },
]
export const STANDARD_ITEM_RULES_SELECT = [{required: true, message: 'Выберите один из пунктов'}]
export const STANDARD_ITEM_RULES_SELECT_MULTIPLE = [
    {required: true, message: 'Выберите пункты из списка'},
]
export const STANDARD_ITEM_RULES_NO_WHITESPACE = [{whitespace: true, message: 'Введите данные'}]

export const STANDARD_ITEM_RULES_CHECKBOX = [
    {
        validator: async (r, v) => {
            if (v !== true) return Promise.reject('Подтвердите условие')
            return Promise.resolve()
        },
    },
]

export const STANDARD_ITEM_RULES_PHONE = [
    {
        validator: async (r, v) => {
            if (!v) return Promise.reject('Введите номер телефона')
            if (!v.match(/^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/))
                return Promise.reject('Введите номер телефона полностью')
            return Promise.resolve()
        },
        required: true,
    },
]

export const STANDARD_ITEM_RULES_EMAIL = [
    {
        validator: async (r, v) => {
            if (!v) return Promise.reject('Укажите e-mail')
            if (!v.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/))
                return Promise.reject('Укажите верный e-mail')
            return Promise.resolve()
        },
        required: true,
    },
]

export const STANDARD_ITEM_RULES_FULLNAME = [
    {
        validator: async (r, v) => {
            if (!v) return Promise.reject('Введите Ф.И.О')
            if (!v.match(/^(?:[A-Za-z|А-Яа-яёЁ]+[ \t]+){2}[A-Za-z|А-Яа-яёЁ]+[ \t]{0,}$/))
                return Promise.reject('Введите Ф.И.О полностью')
            return Promise.resolve()
        },
    },
]

export const STANDARD_ITEM_RULES_PASSPORT_SN_NM = [
    {
        validator: async (r, v) => {
            if (!v) return Promise.reject('Укажите серию и номер паспорта')
            if (!v.match(/^[0-9]{2,}[ ]{1}[0-9]{2,}$/))
                return Promise.reject('Укажите через пробел, пример: 1234 123456')
            return Promise.resolve()
        },
    },
]

export const STANDARD_ITEM_RULES_PASSPORT_SN_NM_RF_ONLY = [
    ...STANDARD_ITEM_RULES,
    {
        validator: async (r, v) => {
            if (!v) return Promise.reject('Укажите серию и номер паспорта')
            if (!v.match(/^[0-9]{4}[ ]{1}[0-9]{6}$/))
                return Promise.reject('Укажите через пробел, пример: 1234 123456')
            return Promise.resolve()
        },
    },
]
export const STANDARD_ITEM_RULES_BC = [
    ...STANDARD_ITEM_RULES,
    {
        validator: async (r, v) => {
            if (!v) return Promise.reject('Укажите серию и номер свидетельства о рождении')
            if (!v.match(/^\S{4,}[ ]{1}[0-9]{6}$/))
                return Promise.reject('Укажите через пробел, пример: II-ИВ 123456')
            return Promise.resolve()
        },
    },
]

export const DATE_PICKER_PLACEHOLDER = '__.__.____'

// имя объекта window['yaCounter21173200'] для основного сайта euro-ins.ru
export const NAME_YM_EUROINS = 'yaCounter21173200'

export const DOMEN =
    ENV_IS_DEV && window?.origin === 'https://api.euro-ins.lh'
        ? 'https://api.euro-ins.lh'
        : ENV_IS_DEV && window?.origin === 'http://api.euro-ins.ru'
        ? 'http://api.euro-ins.ru'
        : window?.origin === 'http://testapi.euro-ins.ru'
        ? 'https://api.euro-ins.lh'
        : 'https://api.euro-ins.ru'
